export default "__VITE_ASSET__UbXO3CkE__"